import { AI_ACT_DATES, hasApplied } from "../lib/aiAct";

const milestones = [
  {
    value: "In force",
    label: "Art. 50 transparency",
    note: "since 2 Aug 2026",
    date: AI_ACT_DATES.transparency,
  },
  {
    value: "2 Dec 2027",
    label: "High-risk, Annex III",
    note: "deferred from 2 Aug 2026",
    date: AI_ACT_DATES.highRiskAnnexIII,
  },
  {
    value: "2 Aug 2028",
    label: "High-risk, Annex I",
    note: "deferred from 2 Aug 2027",
    date: AI_ACT_DATES.highRiskAnnexI,
  },
];

export const AiActStatus = () => (
  <div className="act-status" aria-label="EU AI Act application dates">
    {milestones.map((m) => {
      const live = hasApplied(m.date);
      return (
        <div
          className={live ? "act-status-cell is-live" : "act-status-cell"}
          key={m.label}
        >
          <span className="act-status-value">{m.value}</span>
          <div className="act-status-label">{m.label}</div>
          <div className="act-status-note">{m.note}</div>
        </div>
      );
    })}
  </div>
);
